export default "__VITE_ASSET__MDo4pwom__"